import Index from './index.vue'
import BlankLayout from '../layout/blankLayout.vue'

const prefixPath = '/v-admin/company-culture'

const routes = [
  {
    path: `${prefixPath}`,
    component: Index,
    meta: {
      titleI18nKey: 'admin.notification.title.list'
    }
  }
]

const companyCultureRoute = {
  path: prefixPath,
  redirect: `${prefixPath}`,
  component: BlankLayout,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.notification.title.list',
    permission: ['PERM_COMPANY_CULTURE_EDIT']
  },
  children: routes
}

export default companyCultureRoute
